var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',{class:{mobile: _vm.mobile},attrs:{"fluid":""}},[(_vm.components.includes('tree-map'))?_c('TreeMap'):_vm._e(),(_vm.components.includes('canopy-map'))?_c('CanopyMap'):_vm._e(),(_vm.components.includes('parks-map'))?_c('ParksMap'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }